import Vue from 'vue';
import QRCode from 'qrcode';
import activityUrl from '../constant/activity-url';
import cookie from '../cookie/cookie';
import footer from './footer.vue';
import headNav from './header.vue';
export default Vue.extend({
    name: 'activityBtob',
    components: {
        'el-head-nav': headNav,
        'el-footer': footer,
    },
    computed: {},
    data: function () {
        return {
            currentType: '',
            questionTypes: [],
            isTabTags: false,
            merchantId: '',
        };
    },
    created: function () {
        this.getMerchantId();
    },
    mounted: function () {
        this.$omega.trackEvent('page_Intermediate', {
            tenantcode: this.merchantId,
        });
        this.qrCreated();
    },
    methods: {
        getMerchantId: function () {
            this.merchantId = cookie.getCookie('dafs_merchant_id');
        },
        qrCreated: function () {
            var merchantCode = this.merchantId;
            if (merchantCode === '') {
                return this.$message.error('获取商户号失败');
            }
            var url = "" + window.location.protocol + activityUrl.ACTIVITY_URL + "?tenantCode=" + merchantCode;
            var canvas = document.getElementById('canvas');
            QRCode.toCanvas(canvas, url, function (error) {
                if (error) {
                    console.error(error);
                }
            });
        },
    },
    watch: {},
});
